export default __webpack_public_path__ + "static/media/dog5.db303a99.JPG";